import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { BidCategoryService } from '@http/clients/bid-category.service';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-bid-categories-form-editor',
    templateUrl: './report-bid-categories-form-editor.component.html',
    styleUrls: ['./report-bid-categories-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportBidCategoriesFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportBidCategoriesFormEditorComponent extends FormEditorBase<number[] | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Bid Categories');
    placeholderText = input<string>('Select Bid Categories');

    private readonly bidCategoryService = inject(BidCategoryService);

    async ngOnInit(): Promise<void> {
        const categories = await this.bidCategoryService.search();
        this.items.set(categories);
        this.selectedItems.set(this.mapValueToSelectedItems(this.selectedValue() ?? null));
    }

    protected override async onEntityTextChange(text: string): Promise<void> {
        const categories = await this.bidCategoryService.search(text);
        this.items.set(categories);
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(value: number[] | null): any[] {
        if (!value?.length) return [];
        const selectedIds = new Set(value.map((id) => Number(id)));
        return (this.items() ?? []).filter((item) => selectedIds.has(Number(item.id)));
    }
}
